import { createBrowserHistory } from 'history'
import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { getUserByToken } from '../Actions/UserAction'
import { FullLoader } from '../Components/LoaderBox/Loader'
import NotFound from './NotFound'

export const history = createBrowserHistory()

const RouteWrapper = FullLoader(() => import('./RouteWrapper'))

const routes = [
  {
    path: '/',
    screen: FullLoader(() => import('../Screens/Home/Home'))
  },
  {
    path: '/login',
    screen: FullLoader(() => import('../Screens/Login/Login')),
    headerFooter: false
  },
  {
    path: '/forgot-username',
    screen: FullLoader(() => import('../Screens/Login/ForgotUsername')),
    headerFooter: false
  },
  {
    path: '/forgot-password',
    screen: FullLoader(() => import('../Screens/Login/ForgotPassword')),
    headerFooter: false
  },
  {
    path: '/registration',
    screen: FullLoader(() => import('../Screens/Registration/Registration')),
    headerFooter: false
  },

  {
    path: '/profiles',
    screen: FullLoader(() => import('../Screens/StaticScreens/Profiles'))
    // headerFooter: false
  },
  {
    path: '/jobs',
    screen: FullLoader(() => import('../Screens/StaticScreens/Jobs'))
    // headerFooter: false
  },
  {
    path: '/jobs1',
    screen: FullLoader(() => import('../Screens/StaticScreens/Jobs1')),
    headerFooter: false
  },
  {
    path: '/projects',
    screen: FullLoader(() => import('../Screens/StaticScreens/Projects'))
    // headerFooter: false
  },
  {
    path: '/endorsements',
    screen: FullLoader(() => import('../Screens/StaticScreens/Endorsements'))
    // headerFooter: false
  },
  {
    path: '/market-place',
    screen: FullLoader(() => import('../Screens/StaticScreens/Marketplace'))
    // headerFooter: false
  },
  {
    path: '/pricing',
    screen: FullLoader(() => import('../Screens/Subscriptions/Subscriptions'))
  },
  {
    path: '/cookies-policies',
    screen: FullLoader(() => import('../Screens/StaticScreens/CookiesPolicy'))
  },
  {
    path: '/data-privacy',
    screen: FullLoader(() => import('../Screens/StaticScreens/DataPolicy'))
  },
  {
    path: '/terms-of-use',
    screen: FullLoader(() => import('../Screens/StaticScreens/TermsOfUse'))
  },
  {
    path: '/legal-disclaimer',
    screen: FullLoader(() => import('../Screens/StaticScreens/LegalDisclaimer'))
  },
  {
    path: '/faqs',
    screen: FullLoader(() => import('../Screens/Faqs/Faqs'))
  },
  {
    path: '/contact-us',
    screen: FullLoader(() => import('../Screens/Home/ContactUs'))
  },
  {
    path: '/events',
    screen: FullLoader(() => import('../Screens/Member/Events/Events'))
  },
  {
    path: '/event-details/:id',
    screen: FullLoader(() => import('../Screens/Member/Events/EventView'))
  },
  {
    path: '/app/dashboard',
    screen: FullLoader(() => import('../Screens/Dashboard/AdminDashboard')),
    headerFooter: false
  }
]

function Routes() {
  const dispatch = useDispatch()

  useEffect(() => {
    if (localStorage.getItem('NADA_USER')) {
      dispatch(getUserByToken(localStorage.getItem('NADA_USER')))
    }
  }, [])

  return (
    <Switch>
      {routes.map(({ path, screen, exact = true, headerFooter = true, footer, metaObj }) => (
        <Route
          key={path}
          exact={exact}
          path={path}
          render={(props) => (
            <RouteWrapper
              {...props}
              headerFooter={headerFooter}
              footer={footer}
              metaObj={metaObj}
              screen={screen}
            />
          )}
        />
      ))}

      <Redirect from="/app" to="/" />
      <Route component={NotFound} />
    </Switch>
  )
}

export default memo(Routes)
